<template>
  <div class="videoPage">
    <div v-if="this.$store.state.webNavigator=='pc'">
      <div v-show="pageType">
        <twoLevelList
          :titles="titles"
          :twolist="navLsit"
          :tltType="twolist?'1':'2'"
          :act="active?active:''"
          :classCode="classType"
          :toLeveListPath="toLeveListPath"
          @twoType="clickType"/>

      </div>
      <div class="doctorvideo-list">
        <div class="displayIB positionRE pointEr doctorvideo-bar"
             v-for="(item , index) in videolist"
             :key="index"
             @click="getvideo(item.videoUrl,item.title)">
          <img class="doctorvideo-backimg" :src="httptype(item.coverImg)" :alt="item.title" title="">
          <img class="video-start positionAB video-min-start"
               :src="src1" alt="" title="">
          <p class="col666666 doctorvideo-Tlt overflowText">{{item.title}}</p>
        </div>
      </div>
    </div>
    <div v-if="this.$store.state.webNavigator=='phone'">
      <div class="videoPhone-listBox" :class="titles!='案例视频'?'':'videoPhone-BoxBack'">
        <div>
          <twoLevelList
            :titles="titles"
            :twolist="navLsit"
            :tltType="twolist?'1':'2'"
            :act="active?active:''"
            :classCode="classType"
            :toLeveListPath="toLeveListPath"
            @twoType="clickType"/>
        </div>
        <div v-if="titles!='案例视频'" class="videoPhone-list">
          <div class="videoPhone-listBar displayIB positionRE"
               v-for="(item , index) in videolist"
               :key="index"
               @click="getvideoPhone(item)">
            <div>
              <img class="videoPhone-listImg"
                   :src="httptype(item.coverImg)"
                   :alt="item.title" title="">
              <div class="videoPhone-goto positionAB"></div>
            </div>
            <div>
              <p class="videoPhone-listP overflowText font22phone col666666">{{item.title}}</p>
            </div>
          </div>
        </div>
        <!--        案例视频-->
        <div v-else class="videoPhone-list">
          <div class="phone-videoBox"
               v-for="(item , index) in videolist"
               :key="index"
               @click="getvideoPhone(item)">
            <div class="phone-ImgBox positionRE">
              <img class="phone-videoImg" :src="httptype(item.coverImg)" :alt="item.title" title="">
              <div class="phone-playImg positionAB"></div>
            </div>
            <div class="phone-videoTlt">{{item.title}}</div>
            <div class="font24phone col99999 phone-videoTip">
                            <span class="Time-down  displayIB"></span>
                            <span class="text-down"> {{item.createdAt}} &nbsp;&nbsp;&nbsp;</span>
                            <span class="see-down  displayIB"></span>
                            <span class="text-down"> {{item.playNum}}</span>
            </div>
          </div>
        </div>
        <div v-show="pageLength<count" @click="getMore()" class="phone-more col33333 font22phone marginAuto">
          加载更多
        </div>
      </div>
    </div>
    <div>
      <playVideo v-show="playVideoType" @funcVideo="downvideo" :videoPlay="videoPlay" :videoTlt="videoTlt"/>
    </div>
  </div>
</template>

<script>
// 瘦身百科

// import tltNav from '../../weightLossInfo/tltNav/tltNav';
import "../../../plug/modifyImagePath"
import twoLevelList from '../../../components/twoLevelList/twoLevelList';
import playVideo from '../../../components/playVideo/playVideo';
import config from '@/others/interface';
import {$get, $post, } from '@/others/ajax';
import { myFun } from '../../../plug/modifyImagePath';

export default {
  name: 'videoPage',
  components: {
    twoLevelList, playVideo,
  },
  props: {
    pageType: {
      type: Boolean,
      default: true,
    },
    listType: {
      type: String,
      default: ' ',
    },
    titles: {
      type: String,
      default: null,
    },
    active: {
      type: String,
      default: null,
    },
    classType: {
      type: String,
      default: null,
    },
    pageIndex: {
      type: Number,
      default: 1,
    },
    navLsit: {
      type: Array,
      default: null,
    },
    toLeveListPath: {
      type: String,
      default: '/',
    },
  },
  data () {
    return {
      src1:myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/startmin.png"),
      imgUrl: 'https://jusexcx.zmelo.com/',
      reg: /<\/?.+?\/?>/g,
      videolist: [],
      parameter: this.listType,
      // 二级栏
      twolist: [],
      // 视频播放
      videoPlay: '',
      videoTlt: '',
      playVideoType: false,
      //
      count: '',
      pageSize: '9',
      pageLength: 0,
    };
  },
  watch: {},
  methods: {
    getList () {
      $get(config.zmlgw + '/web/getVideoList', {
        code: this.parameter,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data.rows.length > 0) {
            this.videolist = [...this.videolist, ...res.data.rows, ];
          }
          this.count = res.data.count;
          this.pageLength = this.videolist.length;
          this.$emit('getTotal', this.count);
        }
      });
    },
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return myFun(url);
        }
      }
    },
    getvideo (videoPlay, videoTlt) {
      if (this.videoPlay != '') {
        this.videoPlay = '';
        this.videoTlt = '';
      }
      this.videoPlay = videoPlay;
      this.videoTlt = videoTlt;
      this.playVideoType = true;
    },
    getvideoPhone (item) {
      let videoPlayList = {
        videoPlay: item.videoUrl,
        videoTlt: item.title,
        videoTime: item.createdAt,
        videoLook: item.playNum,
        videoSource: item.secondaryColumnName,
        videoKey: item.keyword,
      };
      sessionStorage.setItem('videoPlayList', JSON.stringify(videoPlayList));
      this.$router.push({path: '/videoNewInfo/shipinxiangqing.html', });
    },
    downvideo (data) {
      this.playVideoType = data;
    },
    clickType (item) {
      this.parameter = item.id;
      this.getList();
    },
    getMore () {
      this.pageIndex += 1;
      this.getList();
    },
  },
  asyncData ({store, route, app, }) {

  },
  mounted () {
    this.getList();
    // this.navList();
  },
  beforeDestroy () {
  },
  computed: {},
  created () {
  },
  filters: {},
};

</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url('../../listPage/videoPage/videoPagePhone');
  }

  @media screen and (min-width: 800px) {
    @import url('../../listPage/videoPage/videoPage');
  }

</style>



// WEBPACK FOOTER //
// videoPage.vue